import {Action, handleActions} from "redux-actions";
import {APPOINTMENTS_SITE_FETCHED, SITE_CREATED, SITE_FETCHED, SITES_FETCHED} from "../../action/site/actionType";
import {SiteState} from "./SiteState";

/**
 * Initial state for site.
 */
const initState: SiteState = {
	sitesMap: {},
	allSitesFetched: false
};

const reducer = handleActions({
	[SITE_CREATED]: (state: SiteState, action: Action<any>): SiteState => { //TODO: There is a bug with typings here. It is present only if action contains payload
		const sites = {...state.sitesMap, [action.payload.site.id]: action.payload.site};
		return {...state, sitesMap: sites}
	},
	[SITES_FETCHED]: (state: SiteState, action: Action<SITES_FETCHED>): SiteState => {
		return {...state, sitesMap: action.payload.sites, allSitesFetched: true}
	},
	[SITE_FETCHED]: (state: SiteState, action: Action<SITE_FETCHED>): SiteState => {
		const sites = {...state.sitesMap, [action.payload.site.id]: action.payload.site};
		return {
			...state, sitesMap: sites
		}
	},
	[APPOINTMENTS_SITE_FETCHED]: (state: SiteState, action: Action<APPOINTMENTS_SITE_FETCHED>): SiteState => {
		const sites = {...state.sitesMap, ...action.payload.sites}
		return {...state, sitesMap: sites}
	},
}, initState);

export default reducer;